import billLogApi from '@/api/billLog/billLogApi';

export default {
	name: 'bill-log',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			billLog: { billStatus: '' }
		};
	},
	computed: {},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init() {
			this.billLog.billStatus = await billLogApi.findBillStatus();
		},

		// 申請實體郵件
		async billLogMailCheck() {
			// billLogMailCheck 成功回傳 randomCode 失敗回傳 'false'
			let code = await billLogApi.billLogMailCheck();
			if (code) {
				this.$router.push({ name: 'bill-log-mail-check', params: { randomCode: code } });
			}
		},

		// 取消實體郵件
		async cancelBillStatus() {
			let res = await billLogApi.cancelBillStatus();
			if (res) {
				// success
				this.$router.push({ name: 'bill-log-mail-result', params: { Msg: '取消申請成功' } });
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/billLog/billLog.js